export default __webpack_public_path__ + "static/hero_1-ee2b66f83dcd192fd3ba03d7e9747fa9.jpg";